import cloudBoltIcon from "../assets/weatherIcon/cloud-bolt-light.svg";
import cloudBoltMoonLightIcon from "../assets/weatherIcon/cloud-bolt-moon-light.svg";
import cloudBoltSunLightIcon from "../assets/weatherIcon/cloud-bolt-sun-light.svg";
import cloudDrizzleLightIcon from "../assets/weatherIcon/cloud-drizzle-light.svg";
import cloudHailLightIcon from "../assets/weatherIcon/cloud-hail-light.svg";
import cloudLightIcon from "../assets/weatherIcon/cloud-light.svg";
import cloudShowerHeavyLightIcon from "../assets/weatherIcon/cloud-showers-heavy-light.svg";
import cloudLigthsIcon from "../assets/weatherIcon/clouds-light.svg";
import hurricaneLightIcon from "../assets/weatherIcon/hurricane-light.svg";
import moonStarsLightIcon from "../assets/weatherIcon/moon-stars-light.svg";
import raindropsLightIcon from "../assets/weatherIcon/raindrops-light.svg";
import snowflakeLightIcon from "../assets/weatherIcon/snowflake-light.svg";
import sunCloudLightIcon from "../assets/weatherIcon/sun-cloud-light.svg";
import sunLightIcon from "../assets/weatherIcon/sun-light.svg";
import temperatureSnowLightIcon from "../assets/weatherIcon/temperature-snow-light.svg";
import temperatureSunLightIcon from "../assets/weatherIcon/temperature-sun-light.svg";
import tornadoLightIcon from "../assets/weatherIcon/tornado-light.svg";
import windLightIcon from "../assets/weatherIcon/wind-light.svg";
import cloudBoltWhiteIcon from "../assets/weatherIconWhite/cloud-bolt-light.svg";
import cloudBoltMoonLightWhiteIcon from "../assets/weatherIconWhite/cloud-bolt-moon-light.svg";
import cloudBoltSunLightWhiteIcon from "../assets/weatherIconWhite/cloud-bolt-sun-light.svg";
import cloudDrizzleLightWhiteIcon from "../assets/weatherIconWhite/cloud-drizzle-light.svg";
import cloudHailLightWhiteIcon from "../assets/weatherIconWhite/cloud-hail-light.svg";
import cloudLightWhiteIcon from "../assets/weatherIconWhite/cloud-light.svg";
import cloudShowerHeavyLightWhiteIcon from "../assets/weatherIconWhite/cloud-showers-heavy-light.svg";
import cloudLigthsWhiteIcon from "../assets/weatherIconWhite/clouds-light.svg";
import hurricaneLightWhiteIcon from "../assets/weatherIconWhite/hurricane-light.svg";
import moonStarsLightWhiteIcon from "../assets/weatherIconWhite/moon-stars-light.svg";
import raindropsLightWhiteIcon from "../assets/weatherIconWhite/raindrops-light.svg";
import snowflakeLightWhiteIcon from "../assets/weatherIconWhite/snowflake-light.svg";
import sunCloudLightWhiteIcon from "../assets/weatherIconWhite/sun-cloud-light.svg";
import sunLightWhiteIcon from "../assets/weatherIconWhite/sun-light.svg";
import temperatureSnowLightWhiteIcon from "../assets/weatherIconWhite/temperature-snow-light.svg";
import temperatureSunLightWhiteIcon from "../assets/weatherIconWhite/temperature-sun-light.svg";
import tornadoLightWhiteIcon from "../assets/weatherIconWhite/tornado-light.svg";
import windLightWhiteIcon from "../assets/weatherIconWhite/wind-light.svg";

export {
  cloudBoltIcon,
  cloudBoltMoonLightIcon,
  cloudBoltSunLightIcon,
  cloudDrizzleLightIcon,
  cloudHailLightIcon,
  cloudLightIcon,
  cloudShowerHeavyLightIcon,
  cloudLigthsIcon,
  hurricaneLightIcon,
  moonStarsLightIcon,
  raindropsLightIcon,
  snowflakeLightIcon,
  sunCloudLightIcon,
  sunLightIcon,
  temperatureSnowLightIcon,
  temperatureSunLightIcon,
  tornadoLightIcon,
  windLightIcon,
  cloudBoltWhiteIcon,
  cloudBoltMoonLightWhiteIcon,
  cloudBoltSunLightWhiteIcon,
  cloudDrizzleLightWhiteIcon,
  cloudHailLightWhiteIcon,
  cloudLightWhiteIcon,
  cloudShowerHeavyLightWhiteIcon,
  cloudLigthsWhiteIcon,
  hurricaneLightWhiteIcon,
  moonStarsLightWhiteIcon,
  raindropsLightWhiteIcon,
  snowflakeLightWhiteIcon,
  sunCloudLightWhiteIcon,
  sunLightWhiteIcon,
  temperatureSnowLightWhiteIcon,
  temperatureSunLightWhiteIcon,
  tornadoLightWhiteIcon,
  windLightWhiteIcon,
};

/**
 * The icons above drawn in one dark colour, which Theme Studio repaints with the
 * partner's Icons colour (constant/neutralIcons.ts → the `zv-icon` class). Add an
 * icon here when it is a single dark colour shown on a page, card, field or menu.
 */
export const NEUTRAL_WEATHER_ICON_SRCS: string[] = [
  cloudBoltIcon, cloudBoltMoonLightIcon, cloudBoltSunLightIcon, cloudDrizzleLightIcon, cloudHailLightIcon,
  cloudLightIcon, cloudLigthsIcon, cloudShowerHeavyLightIcon, hurricaneLightIcon, moonStarsLightIcon,
  raindropsLightIcon, snowflakeLightIcon, sunCloudLightIcon, sunLightIcon, temperatureSnowLightIcon,
  temperatureSunLightIcon, tornadoLightIcon, windLightIcon,
];
